// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-about-us.scss';

// libs
import RecruitFV from '../_libs/RecruitFV';

// utils
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	const $service = document.querySelector('.js-service');
	if ($service) {
		const $background = $service.querySelector('.js-service-background');
		const $itemTrigger = $service.querySelectorAll(
			'.js-service-item-trigger'
		);

		ScrollTrigger.create({
			trigger: $itemTrigger,
			start: 'top 70%',
			end: 'top 70%',
			onEnter: () => {
				$background.classList.add('is-active');
			},
			onEnterBack: () => {
				$background.classList.remove('is-active');
			},
		});
	}

	const $features = document.querySelector('.js-features');
	if ($features) {
		const $paginationList = $features.querySelector(
			'.js-features-pagination-list'
		);
		const $$trigger = $features.querySelectorAll('.js-features-trigger');
		const $$item = $features.querySelectorAll('.js-features-item');

		$$item.forEach(($item, i) => {
			$item.classList.add('is-init');

			/**
			 * @type {any}
			 */
			let itemNumber = i + 1;
			if (itemNumber < 10) {
				itemNumber = `0${itemNumber}`;
			}
			const $paginationItem = document.createElement('div');
			$paginationItem.classList.add(
				'pFeatures__pagination_item',
				'js-features-pagination-item'
			);
			$paginationItem.setAttribute(
				'data-id',
				$item.getAttribute('data-id')
			);
			$paginationItem.innerHTML = `
			<div class="pFeatures__pagination_number">${itemNumber}</div>
			<div class="pFeatures__pagination_line">
				<div class="pFeatures__pagination_line_track"></div>
				<div class="pFeatures__pagination_line_thumb js-features-pagination-line-thumb"></div>
			</div>
			`;
			$paginationList.appendChild($paginationItem);
		});

		$$trigger.forEach(($trigger, i) => {
			const id = $trigger.getAttribute('data-id');

			ScrollTrigger.create({
				trigger: $trigger,
				start: 'top 70%',
				end: 'bottom 70%',
				onEnter: () => {
					$$item.forEach(($item) => {
						if ($item.getAttribute('data-id') === id) {
							$item.classList.add('is-active');

							const $paginationItem = $features.querySelector(
								`.js-features-pagination-item[data-id="${id}"]`
							);
							$paginationItem.classList.add('is-active');
						}
					});
				},
				onLeave: () => {
					$$item.forEach(($item) => {
						// 最後は処理をしない
						if (i === $$trigger.length - 1) {
							return;
						}

						if ($item.getAttribute('data-id') === id) {
							$item.classList.remove('is-active');

							const $paginationItem = $features.querySelector(
								`.js-features-pagination-item[data-id="${id}"]`
							);
							$paginationItem.classList.remove('is-active');
						}
					});
				},
				onEnterBack: () => {
					$$item.forEach(($item) => {
						if ($item.getAttribute('data-id') === id) {
							$item.classList.add('is-active');

							const $paginationItem = $features.querySelector(
								`.js-features-pagination-item[data-id="${id}"]`
							);
							$paginationItem.classList.add('is-active');
						}
					});
				},
				onLeaveBack: () => {
					$$item.forEach(($item) => {
						if ($item.getAttribute('data-id') === id) {
							$item.classList.remove('is-active');

							const $paginationItem = $features.querySelector(
								`.js-features-pagination-item[data-id="${id}"]`
							);
							$paginationItem.classList.remove('is-active');
						}
					});
				},
			});

			const $paginationItem = $features.querySelector(
				`.js-features-pagination-item[data-id="${id}"]`
			);
			const $paginationLineThumb = $paginationItem.querySelector(
				'.js-features-pagination-line-thumb'
			);
			gsap.fromTo(
				$paginationLineThumb,
				{
					scaleY: 0,
				},
				{
					scaleY: 1,
					ease: 'none',
					scrollTrigger: {
						trigger: $trigger,
						start: 'top 70%',
						end: 'bottom 70%',
						scrub: true,
					},
				}
			);
		});
	}
});

window.addEventListener('load', () => {
	ScrollTrigger.refresh();

	RecruitFV();
});

let vw = document.documentElement.clientWidth;
window.addEventListener('resize', () => {
	if (vw === document.documentElement.clientWidth) {
		return;
	}
	vw = document.documentElement.clientWidth;
	location.reload();
});
